import { JWT_KEY } from "../config/constant";
import { Stage } from "../interface/carddeck";

export const isValidEmail = (email: string) => {
  return email.match(
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3,4}$/
  );
};

export const isValidPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.match(/^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/);
};

export const getUserAgent = () => {
  const userAgent = window.navigator.userAgent;

  const isIPadOS =
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform);

  if (userAgent.match(/Android/i)) return "android";
  else if (userAgent.match(/iPhone|iPod/i)) return "apple";
  else if (/iPad|Macintosh.*Safari/i.test(userAgent) || isIPadOS)
    return "apple";
  else return "web";
};

export type PlatformType = "android" | "apple" | "web";

export function detectPlatform(): PlatformType {
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  const isIPadOS =
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform);

  if (/android/i.test(userAgent)) {
    return "android";
  }
  if (/iPad|Macintosh.*Safari/i.test(userAgent) || isIPadOS) {
    return "apple";
  }
  if (/iPhone|iPod/i.test(userAgent)) {
    return "apple";
  }
  return "web";
}

export const isLoggedIn = () => {
  if (
    window.localStorage.getItem(JWT_KEY) &&
    window.localStorage.getItem(JWT_KEY) !== "" &&
    window.localStorage.getItem("brainy_refresh_token") &&
    window.localStorage.getItem("brainy_refresh_token") !== ""
  )
    return true;
  else return false;
};

export const getCurrentYearMonth = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  return `${year}.${month < 10 ? `0${month}` : month}`;
};

export const getFontSize = (length: number) => {
  if (!length) return "md";
  if (length < 50) return "lg";
  else return "md";
};

/**
 * 단일 진동 울리기
 * @param time 진동 시간 (밀리초)
 */
export const singleVibrate = (time: number) => {
  // 사용자 기기에 따라 다른 동작 처리
  switch (getUserAgent()) {
    case "android":
      // 안드로이드일 경우
      if (window.Android?.singleVibrate) window.Android?.singleVibrate(time);
      break;
    //
    case "apple":
      // iOS일 경우
      if (window.webkit?.messageHandlers?.singleVibrate)
        window.webkit?.messageHandlers?.singleVibrate.postMessage({
          time,
        });
      break;
    default:
      // 이외 기기는 지원하지 않으므로 넘어가기
      break;
  }
};

interface StudyLastStage {
  cardDeckId: string;
  stage: Stage;
}

export const setLastStudyStage = (
  cardDeckId?: string,
  stage?: Stage | null
) => {
  if (!cardDeckId || !stage) {
    window.sessionStorage.removeItem("studyLastStage");
    return;
  }

  const value: StudyLastStage = {
    cardDeckId,
    stage,
  };

  window.sessionStorage.setItem("studyLastStage", JSON.stringify(value));
};

export const getLastStudyStage = (): StudyLastStage | null => {
  const getValue = window.sessionStorage.getItem("studyLastStage");
  if (!getValue) return null;
  return JSON.parse(getValue);
};

export const getCurrencyFormat = (value: number) => {
  return value.toLocaleString("ko-KR");
};
